// extracted by mini-css-extract-plugin
module.exports = {"container":"content_image_single-module--container--1HQv2","image":"content_image_single-module--image--1rAwo"};